module.exports = __webpack_public_path__ + "static/img/activity22.1f0e4066.png";